export default __webpack_public_path__ + "static/media/left-shrink.e238b25b.svg";